import { put, select, take, takeEvery } from 'redux-saga/effects'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { createBestTrackingAPI, updateOrderStatusAPI, countNewOrderAPI } from './api'

function* createBestTracking(action: any): any {
  const { createTracking, updateStatus, token, xmid } = action.payload
  try {
    yield put(createBestTrackingAPI(createTracking, token))
    const resp: any = yield take(actions.createBestTrackingAction.success)
    if (resp) {
      yield put(updateOrderStatusAPI(updateStatus, token, xmid))
    }
  } catch (e) {
    yield put(actions.updateAction.failure(e))
  }
}

export const getUser = (state: any) => state.userReducer.currentUser

function* countNewOrder(): any {
  try {
    const currentUser = yield select(getUser)
    yield put(countNewOrderAPI({}, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  } catch (e) {
    console.log(e)
  }
}

function* orderSaga() {
  yield takeEvery(getType(actions.createBestTracking), createBestTracking)
  yield takeEvery(getType(actions.updateAction.success), countNewOrder)
}

export default orderSaga
